import { render, staticRenderFns } from "./ZoomStarterPage.vue?vue&type=template&id=1ecd4022&scoped=true&"
import script from "./ZoomStarterPage.vue?vue&type=script&lang=js&"
export * from "./ZoomStarterPage.vue?vue&type=script&lang=js&"
import style0 from "./ZoomStarterPage.vue?vue&type=style&index=0&id=1ecd4022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd4022",
  null
  
)

export default component.exports